var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-map"},[_c('van-loading',{staticClass:"loading-center",attrs:{"loading-text":"加载中...","size":"50"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }